import HeroImage from "@/components/heroImage";

export default function Contact() {
  return (
    <>
      <HeroImage
        imageSrc="/images/about/aia-logo.svg"
        imageAltText="logo"
        title="Contact Page"
      />
    </>
  );
}

